import { CustomerRoutes } from './customerSubRoutes/CustomerSubRoutes'
import { IRoute } from '../models/routes/IRoute'

const customerRoutes: IRoute[] = [
  ...CustomerRoutes,
]

export default customerRoutes;

